import { useState, useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'
import './header.css'
import './hamburger.css'
import { UserNav } from './navigation/UserNav'
import { useLocation, Link } from 'react-router-dom'
import HeaderNavItems from './navigation/HeaderNavItems'
import MobileMenuToggle from './MobileMenuToggle'
import { LogoutButton } from './buttons/logout-button'

const Header = () => {
    const { isAuthenticated } = useAuth0()
    const location = useLocation()
    const [isActive, setIsActive] = useState(false)

    useEffect(() => {
        setIsActive(false)
    }, [location])

    return (
        <header className={`main-header ${isActive ? 'main-header--active' : ''}`}>
            <div className="main-header-inner">
                <Link to="/" className="main-header-logo">
                    <img src="/dimedock-logo-cropped-white-transparent.png" alt="logo" />
                </Link>

                <nav className={`main-header-nav`}>
                    <ul className="main-header-nav-list">
                        <HeaderNavItems />
                    </ul>
                    <div className="main-header-mobile-footer">
                        <LogoutButton />
                    </div>
                </nav>

                <div className="main-header-tools">
                    {isAuthenticated && <MobileMenuToggle isActive={isActive} setIsActive={setIsActive} />}
                    <UserNav />
                </div>
            </div>

            {/* {isActive && (
                <div className="main-header-mobile-footer">
                    <LogoutButton />
                </div>
            )} */}
        </header>
    )
}

export default Header
